import PokerTableSeatPokers from "../../../table/module/poker_table/poker_seat_pokers_base";
import TransformHolder from "./transformHolder";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import PromiseUtility from "../../../../utility/promiseUtility";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/BiPaiSeatCards")
export default class BiPaiSeatCards extends PokerTableSeatPokers{
    @property([TransformHolder])
    transformHolderList: TransformHolder[] = []

    @property(TransformHolder)
    fromTransformHolder: TransformHolder = null

    playFaPaiAnim(codeList: number[], duration: number, interval: number, delay: number, onFinish?: Function, onStart?: Function){
        let self = this
        this.showPokers(true, codeList)
        let pokers = this.pokers
        let fromTranData = this.fromTransformHolder.transformDataList[0]
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            let node = poker.node
            node.position = node.parent.convertToNodeSpaceAR(fromTranData.worldPos)
            let tmpTranData = self.getPosData(index, index + 1)
            node.angle = fromTranData.angle
            node.scale = fromTranData.scale
            node.active = false
            self.scheduleOnce(function(){
                node.active = true      
                let targetLocalPos = node.parent.convertToNodeSpaceAR(tmpTranData.worldPos)          
                self.playNodeAnim(node, targetLocalPos, tmpTranData.scale, tmpTranData.angle, duration, 0, null, cc.easeCubicActionOut(), function(){
                    onStart && onStart(index)
                })
                let nodeList = []
                for (let i = 0; i < index; i++) {                    
                    nodeList.push(pokers[i].node)
                }
                self.playAdjustAnim(nodeList, index + 1, interval * 2, duration * 0.5, function(){
                    index == pokers.length - 1 && onFinish && onFinish()
                }) 
            }, delay + interval * index)
        }
    }
    
    playMoPaiAnim(code: number, codeList: number[], duration: number, onFinish?: Function){
        let self = this
        let fromTranData = self.fromTransformHolder.transformDataList[0]
        let pokers = self.pokers
        let poker = self.genPoker(code)  
        let tranData = self.getPosData(codeList.length - 1, codeList.length)
        poker.showBack(!code)
        poker.showFace(!!code)
        pokers.push(poker)
        poker.node.position = poker.node.parent.convertToNodeSpaceAR(fromTranData.worldPos)
        poker.node.angle = fromTranData.angle
        poker.node.scale = fromTranData.scale
        poker.node.active = true
        poker.node.zIndex = tranData.zIndex
        let nodeList = []
        for (let i = 0; i < pokers.length - 1; i++) {                   
            nodeList.push(pokers[i].node)  
        }
        
        let targetPos = poker.node.parent.convertToNodeSpaceAR(tranData.worldPos)
        self.playNodeAnim(poker.node, targetPos, tranData.scale, tranData.angle, duration, 0, null, cc.easeCubicActionOut())
        self.playAdjustAnim(nodeList, nodeList.length + 1, duration * 0.42, duration * 0.8, function(){
            self.showPokers(true, codeList)
            onFinish && onFinish()
        })
    }

    showPokers(show: boolean, codeList?: number[], params?: any){
        let self = this
        this.unscheduleAllCallbacks()
        this.removeAllPokers()        
        if(show){
            let pokerList = this.genPokerList(codeList, false)
            let nodeList = []
            for (let index = 0; index < pokerList.length; index++) {
                let poker = pokerList[index]    
                poker.show()
                poker.showFace(poker.code != 0)
                poker.showBack(poker.code == 0)
                nodeList.push(poker.node)
                if(params){
                    if(params.hidePoker){
                        poker.hide()
                    }
                    if(params.showBack){
                        poker.showBack(true)
                        poker.showFace(false)
                    }
                }                                         
            }
            let targetCount = 0
            if(params && params){
                targetCount = params.targetLayoutCount
            }
            let centerLocalPos = this.formatPokersLayout(pokerList, targetCount)

            if(params){
                if(params.playAdjustAnim){
                    self.playAdjustAnim(nodeList, nodeList.length, params.duration, params.delay, function(){
                        self.showPokers(true, codeList)
                        params.onFinishPlayAdjustAnim && params.onFinishPlayAdjustAnim()
                    })
                }
            }

            let worldPos = this.nodePokersParent.convertToWorldSpaceAR(centerLocalPos)
            return worldPos
        }
        return cc.Vec2.ZERO
    }

    protected playAdjustAnim(nodeList: cc.Node[], targetCount: number, duration: number, delay?: number, onFinish?: Function, easingType?){
        let self = this
        if(targetCount == 0){
            onFinish && onFinish()
            return
        }
        let doFuns = []
        for (let index = 0; index < nodeList.length; index++) {
            const node = nodeList[index];
            let data = self.getPosData(index, targetCount)
            let targetPos = node.parent.convertToNodeSpaceAR(data.worldPos)
            doFuns.push(function(cb){self.playNodeAnim(node, targetPos, data.scale, data.angle, duration, delay, cb, easingType)})
        }
        if(doFuns.length == 0){
            onFinish && onFinish()
            return
        }
        PromiseUtility.race(doFuns).then(function(){
            onFinish && onFinish()
        })
    }

    protected playNodeAnim(node: cc.Node, targetPos: cc.Vec2, targetScale: number, targetAngle: number, duration: number, delay?: number, onFinish?: Function, easingType?, onStart?: Function){
        let self = this
        let do_fun = function(){
            onStart && onStart()
            let moveAnim = cc.moveTo(duration, targetPos)            
            let rotaAnim = cc.rotateTo(duration, targetAngle)
            let scaleAnim = cc.scaleTo(duration, targetScale)
            if(easingType){
                moveAnim = moveAnim.easing(easingType)
                rotaAnim = rotaAnim.easing(easingType)
                scaleAnim = scaleAnim.easing(easingType)
            }
            let tmpFun = function(){
                self.setNodeActionCallback(node, null)
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)    
            self.checkAndDealCallback(node)
            node.active = true     
            self.setNodeActionCallback(node, tmpFun)
            let swap = cc.spawn([moveAnim, rotaAnim, scaleAnim])
            var seq = cc.sequence([swap, callFun])
            node.stopAllActions()
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected playFadeAnim(node: cc.Node, from: number, to: number, duration: number, delay?: number, onFinish?: Function){
        let self = this
        let do_fun = function(){
            node.opacity = from
            let fadeAnim = cc.fadeTo(duration, to)
            let tmpFun = function(){
                self.setNodeActionCallback(node, null)
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)    
            self.checkAndDealCallback(node)   
            node.active = true    
            self.setNodeActionCallback(node, tmpFun)
            var seq = cc.sequence([fadeAnim, callFun])
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected formatPokersLayout(pokerList: PokerTablePokerBase[], targetCount?: number): cc.Vec2{
        if((!pokerList || pokerList.length == 0) && !targetCount){
            return cc.Vec2.ZERO
        }
        targetCount = targetCount || pokerList.length
        for (let i = 0; i < pokerList.length; i++) {
            let poker = pokerList[i];          
            let data = this.getPosData(i, targetCount)  
            let localPos = poker.node.parent.convertToNodeSpaceAR(data.worldPos)
            poker.node.position = localPos
            poker.original_pos = localPos
            poker.node.zIndex = data.zIndex
            poker.node.angle = data.angle 
            poker.original_angle = data.angle
            poker.node.scale = data.scale || 1
            poker.original_scale = poker.node.scale
        }
        return cc.Vec2.ZERO
    }

    protected getPosData(index: number, count: number){
        let data = this.transformHolderList[count - 1].transformDataList[index]        

        return data
    }

    protected checkAndDealCallback(node: cc.Node){
        let self = this
        let lastFun = self.getNodeActionCallback(node)            
        if(lastFun){            
            lastFun()
            return self.checkAndDealCallback(node)
        }  
    }

    protected setNodeActionCallback(node: cc.Node, callback: Function){
        node['_action_callback'] = callback
    }    

    protected getNodeActionCallback(node: cc.Node){
        return node['_action_callback']
    }
}
